import { toast } from 'sonner';
import type { Notification } from '@/features/notifications/domain/model/notification';

export function tryShowBrowserNotification(row: Notification) {
  if (typeof window === 'undefined' || !('Notification' in window)) return;
  if (Notification.permission !== 'granted') return;

  const userProbablyWatching =
    document.visibilityState === 'visible' && typeof document.hasFocus === 'function' && document.hasFocus();
  if (userProbablyWatching) return;

  try {
    new Notification(row.title, {
      body: row.body,
      tag: row.id,
    });
  } catch (e) {
    console.error('Error al mostrar notificación del navegador:', e);
  }
}

export function triggerToastNotification(row: Notification) {
  const type = row.type?.toLowerCase();

  if (type === 'security' || type === 'out_of_stock' || type === 'error') {
    toast.error(row.title, { description: row.body });
  } else if (type === 'warning' || type === 'stock_warning') {
    toast.warning(row.title, { description: row.body });
  } else if (type === 'order') {
    toast.success(row.title, { description: row.body });
  } else {
    toast.info(row.title, { description: row.body });
  }
}
